import {
  HedgePlanOverHedgeLimit,
  MatrixCalculationType,
  MatrixContractSettlement,
  MatrixSeasonType,
  MatrixStripType,
  MatrixTerm,
  VolumeSource,
} from '../../../../Generated/Commodity-Management-Api';

// Wording matches Tools/Matrix/MatrixLabels.ts so the same setting reads the same in both tools.
export const SeasonTypeLabels: Record<MatrixSeasonType, string> = {
  [MatrixSeasonType.Annual]: 'Annual',
  [MatrixSeasonType.WinterSummer]: 'Winter-Summer',
  [MatrixSeasonType.Quarterly]: 'Quarterly',
};

export const TermLabels: Record<MatrixTerm, string> = {
  [MatrixTerm.Annual]: 'Annual',
  [MatrixTerm.Summer]: 'Summer',
  [MatrixTerm.Winter]: 'Winter',
  [MatrixTerm.FirstQuarter]: 'Q1',
  [MatrixTerm.SecondQuarter]: 'Q2',
  [MatrixTerm.ThirdQuarter]: 'Q3',
  [MatrixTerm.FourthQuarter]: 'Q4',
  [MatrixTerm.JanuaryFebruary]: 'January-February',
  [MatrixTerm.MarchApril]: 'March-April',
  [MatrixTerm.JulyAugust]: 'July-August',
  [MatrixTerm.OctoberDecember]: 'October-December',
  [MatrixTerm.Custom]: 'Custom',
};

export const CalculationTypeLabels: Record<MatrixCalculationType, string> = {
  [MatrixCalculationType.Monthly]: 'Monthly',
  [MatrixCalculationType.Expiration]: 'Expiration',
};

export const ContractSettlementLabels: Record<MatrixContractSettlement, string> = {
  [MatrixContractSettlement.ExpirationDate]: 'Expiration Date',
  [MatrixContractSettlement.LastDayOfTheMonth]: 'Last Day of Month',
};

export const StripTypeLabels: Record<MatrixStripType, string> = {
  [MatrixStripType.FirstContractMonth]: '1st Contract Month (NG Settlement)',
  [MatrixStripType.SecondContractMonth]: '2nd Contract Month',
  [MatrixStripType.Strip]: '12 Month Strip',
  [MatrixStripType.ContractPeriod]: 'Forward Contract',
  [MatrixStripType.RollingMonth]: '1st Contract Month',
};

export const VolumeSourceLabels: Record<VolumeSource, string> = {
  [VolumeSource.None]: 'None',
  [VolumeSource.CommodityManagement]: 'Commodity Management',
  [VolumeSource.KnowRiskEnergy]: 'Know Risk Energy',
};

export const OverHedgeLimitLabels: Record<HedgePlanOverHedgeLimit, string> = {
  [HedgePlanOverHedgeLimit.Hundred]: '100%',
  [HedgePlanOverHedgeLimit.MaxTarget]: 'Max Target',
};
